import React, { useContext } from 'react';
import { MessagePropertiesContext } from '../../../../../../contexts/messageProperties';
import { ProductStatusOnListerPage } from '../../../../../../types';
import statusStyles from './status.module.pcss';

interface StatusProps {
  productStatusOnListerPage: ProductStatusOnListerPage;
}

function Status({ productStatusOnListerPage }: StatusProps): React.ReactElement | null {
  const [formattedMessage] = useContext(MessagePropertiesContext);

  const productStatus = {
    OutOfStock: formattedMessage({ id: 'product.stock.status.LiveActive.outOfStock', fallback: 'Out of stock' }),
    Archived: formattedMessage({ id: 'product.stock.status.Archived', fallback: 'Out of stock' }),
    StoreOnly: formattedMessage({ id: 'product.stock.status.LiveRetailOnly.short', fallback: 'In store only' }),
    ComingSoon: formattedMessage({ id: 'product.stock.status.LiveComingSoon', fallback: 'Coming Soon' })
  };

  return productStatusOnListerPage && productStatus[productStatusOnListerPage] ? (
    <div className={statusStyles.status}>
      <div className={statusStyles['status__text']}>{productStatus[productStatusOnListerPage]}</div>
    </div>
  ) : null;
}

export default Status;
